import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    autoDismiss: { type: Boolean, default: true },
    delay: { type: Number, default: 3000 }
  }

  connect() {
    this.enter()

    if (this.autoDismissValue) {
      this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  enter() {
    requestAnimationFrame(() => {
      this.element.classList.remove("opacity-0", "translate-x-4")
      this.element.classList.add("opacity-100", "translate-x-0")
    })
  }

  dismiss() {
    clearTimeout(this.timeout)

    this.element.classList.remove("opacity-100", "translate-x-0")
    this.element.classList.add("opacity-0", "translate-x-4")

    this.timeout = setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
